import { ComponentInstance } from "./component-instance";
import ConfirmDialog from "@/components/ui/ConfirmDialog.vue";
export class DialogHelper {
  static showDialog(
    component,
    { text, buttonText, ...props },
    eventsAndCallbacks
  ) {
    const componentInstance = new ComponentInstance();
    componentInstance.setInstance(component, {
      data: {
        text,
        buttonText
      },
      ...props
    });
    componentInstance.addToAppWrapper();
    for (const eventAndCallback of eventsAndCallbacks) {
      componentInstance.instance.$children[0].$on(
        eventAndCallback.event,
        val => {
          eventAndCallback.callback();
        }
      );
    }
  }

  static showConfirmDialog(props, callback) {
    const componentInstance = new ComponentInstance();
    componentInstance.setInstance(ConfirmDialog, props);
    componentInstance.addToAppWrapper();
    componentInstance.instance.$children[0].$on("confirmed", val => {
      if (val) {
        callback();
      }
    });
  }
}
